interface IconProps {
  url: string;
}

interface HeroImageUrl {
  '@1x': string;
  '@2x': string;
}

export interface AtomProps {
  button?: JSX.Element;
  className?: string;
  icon: IconProps;
  name: string;
  subtitle?: string;
}

export interface DescriptionAtomProps extends AtomProps {
  overview: string;
}

export interface FeaturedAtomProps extends DescriptionAtomProps {
  heroImageUrl: HeroImageUrl;
}

export type PowerUpAtomProps =
  | AtomProps
  | DescriptionAtomProps
  | FeaturedAtomProps;

export enum PowerUpItemType {
  Basic,
  Description,
  Featured,
}
